
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { LogicType } from '@/types';

@Component
export default class MultiBoolSelect extends Vue {
  @Prop(Array) readonly value!: [];
  @Prop({ type: String, default: 'AND' }) readonly logic!: LogicType
  @Prop(Array) readonly items!: [];
  @Prop({ type: String, default: 'Tutti' }) readonly placeholder!: string
  @Prop(String) readonly label: string | null | undefined;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean
  @Prop({ type: Boolean, default: false }) readonly andDisabled!: boolean
  @Prop({ type: Array, default: () => [] }) readonly negated!: (number | string)[]

  searchInput = null

  selectedItems = []
  selectedLogic: LogicType = this.andDisabled ? 'AND' : 'OR';
  negatedIds: (number | string)[] = []

  created() {
    // console.log('MultiBoolSelect: created()'); // eslint-disable-line no-console

    this.selectedItems = this.value;
    this.selectedLogic = this.logic;
    this.negatedIds = [...(this.negated || [])];
  }

  @Watch('value')
  onValueChange(val: []) {
    console.log('MultiBoolSelect: onValueChange() val =', val); // eslint-disable-line no-console

    this.selectedItems = this.value;
  }

  @Watch('logic')
  onLogicChange(val: LogicType) {
    console.log('MultiBoolSelect: onLogicChange() val =', val); // eslint-disable-line no-console

    this.selectedLogic = val;
    if (val === 'NOT') {
      this.negatedIds = [];
      this.onUpdate();
    }
  }

  @Watch('negated')
  onNegatedChange(val: (number | string)[]) {
    this.negatedIds = [...(val || [])];
  }

  // isItemHidden(id: number): boolean {
  //   const fullItem = this.fullItem(id);
  //   return fullItem && 'hidden' in fullItem && fullItem.hidden;
  // }

  isNegated(id: number | string): boolean {
    return this.negatedIds.indexOf(id) !== -1;
  }

  chipColor(id: number | string): string {
    if (this.selectedLogic === 'NOT') {
      return 'error';
    }
    if (this.selectedLogic === 'AND' || this.selectedLogic === 'OR') {
      return this.isNegated(id) ? 'error' : 'success';
    }
    return 'blue-grey';
  }

  onChipClick(event: Event, data: any) {
    if (this.selectedLogic === 'AND' || this.selectedLogic === 'OR') {
      const id = data.item?.id;
      if (id !== null && id !== undefined) {
        event.stopPropagation();
        this.toggleNegated(id);
      } else {
        data.select(event);
      }
    } else {
      data.select(event);
    }
  }

  toggleNegated(id: number | string | null | undefined) {
    if (id === null || id === undefined) return;
    const idx = this.negatedIds.indexOf(id);
    if (idx === -1) {
      this.negatedIds = [...this.negatedIds, id];
    } else {
      this.negatedIds = this.negatedIds.filter((x) => x !== id);
    }
    this.onUpdate();
  }

  removeItem(id: number | string) {
    console.log(`MultiBoolSelect: removeItem(${id})`); // eslint-disable-line no-console

    this.selectedItems = this.selectedItems.filter((itemId: number | string) => itemId !== id);
    this.negatedIds = this.negatedIds.filter((x) => x !== id);

    this.onUpdate();
  }

  fullItem(id: number): any {
    return this.items.find((c: any) => 'id' in c && c.id === id);
  }

  nextLogic() {
    console.log('MultiBoolSelect: nextLogic()'); // eslint-disable-line no-console

    if (this.selectedLogic === 'AND') {
      this.selectedLogic = 'OR';
    } else
    if (this.selectedLogic === 'OR') {
      this.selectedLogic = 'NOT';
    } else
    if (this.selectedLogic === 'NOT') {
      this.selectedLogic = this.andDisabled ? 'OR' : 'AND';
    }

    if (this.selectedLogic === 'NOT') {
      this.negatedIds = [];
    }
    this.onUpdate();
  }

  onUpdate() {
    console.log('MultiBoolSelect: onUpdate()'); // eslint-disable-line no-console

    const negatedToEmit = this.selectedLogic === 'NOT' ? [] : this.negatedIds;
    this.$emit('update', this.selectedItems, this.selectedLogic, negatedToEmit);
  }

  onKeyUp() {
    console.log('MultiBoolSelect: onUpdate()'); // eslint-disable-line no-console

    this.$emit('keyup');
  }
}
